// extracted by mini-css-extract-plugin
export default {"arrowBackWhite":"styles_arrowBackWhite__erVr7","arrowBackRed":"styles_arrowBackRed__wi1Yj","errorWebRTC":"styles_errorWebRTC__KHpIU"};